interface EmptyAccountsStateProps {
  onAddAccount: () => void
}

export default function EmptyAccountsState({ onAddAccount }: EmptyAccountsStateProps) {
  return (
    <div style={{
      backgroundColor: 'var(--container-bg)',
      borderRadius: '8px',
      border: '1px solid var(--border-color)',
      padding: '4rem 2rem',
      textAlign: 'center',
      margin: '2rem 0'
    }}>
      <div style={{
        fontSize: '3rem',
        marginBottom: '1rem',
        opacity: 0.6
      }}>
        💰
      </div>
      
      <h3 style={{
        color: 'var(--text-light)',
        fontSize: '1.5rem',
        marginBottom: '1rem',
        fontWeight: '600'
      }}>
        No Accounts Yet
      </h3>
      
      <p style={{
        color: 'var(--text-muted)',
        fontSize: '1rem',
        marginBottom: '2rem',
        lineHeight: '1.5',
        maxWidth: '400px',
        margin: '0 auto 2rem auto'
      }}>
        Start tracking your net worth by creating your first account. 
        Add your assets like savings accounts, investments, and property, 
        or liabilities like loans and credit cards.
      </p>
      
      <button
        onClick={onAddAccount}
        style={{
          padding: '1rem 2rem',
          backgroundColor: 'var(--primary-blue)',
          border: 'none',
          borderRadius: '6px',
          color: 'white',
          cursor: 'pointer',
          fontSize: '1.1rem',
          fontWeight: '600',
          transition: 'all 0.2s ease',
          boxShadow: '0 2px 8px rgba(0, 176, 255, 0.3)'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = '#0099e6'
          e.currentTarget.style.transform = 'translateY(-1px)'
          e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 176, 255, 0.4)'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'var(--primary-blue)'
          e.currentTarget.style.transform = 'translateY(0)'
          e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 176, 255, 0.3)'
        }}
      >
        Create Your First Account
      </button>
      
      <div style={{
        marginTop: '2rem',
        padding: '1rem',
        backgroundColor: 'var(--page-bg)',
        borderRadius: '4px',
        border: '1px solid var(--border-color)'
      }}>
        <p style={{
          color: 'var(--text-muted)',
          fontSize: '0.875rem',
          margin: 0,
          lineHeight: '1.4'
        }}>
          💡 <strong style={{ color: 'var(--text-light)' }}>Tip:</strong> You can organize accounts by type (Assets vs Liabilities) 
          and track liquid, semi-liquid, and illiquid values for each account.
        </p>
      </div>
    </div>
  )
}